import { render } from "./ytj.vue?vue&type=template&id=1f818091&scoped=true"
import script from "./ytj.vue?vue&type=script&lang=js"
export * from "./ytj.vue?vue&type=script&lang=js"

import "./ytj.vue?vue&type=style&index=0&id=1f818091&lang=less&scoped=true"

import exportComponent from "/Users/a/k618/work/sxdsjtj/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f818091"]])

export default __exports__